import HelpIcon from "@mui/icons-material/Help";
import { Stack, TextField, Tooltip } from "@mui/material";
import { Dispatch, SetStateAction, useCallback } from "react";

export type FullName = { givenName: string; familyName: string };
type CustomerInfoFormProps = {
  email: string;
  phoneNumber: string;
  sourceBookingId: string;
  names: FullName[];
  setEmail: Dispatch<SetStateAction<string>>;
  setPhoneNumber: Dispatch<SetStateAction<string>>;
  setSourceBookingId: Dispatch<SetStateAction<string>>;
  setNames: Dispatch<SetStateAction<FullName[]>>;
};
export default function CustomerInfoForm({
  email,
  names,
  phoneNumber,
  sourceBookingId,
  setEmail,
  setNames,
  setPhoneNumber,
  setSourceBookingId,
}: CustomerInfoFormProps) {
  const updateName = useCallback(
    (index: number) => (partialName: Partial<FullName>) => {
      setNames((prevNames) => [
        ...prevNames.slice(0, index),
        { ...prevNames[index], ...partialName },
        ...prevNames.slice(index + 1),
      ]);
    },
    []
  );

  return (
    <Stack spacing={1}>
      {names.map((name, index) => (
        <Stack key={index} direction="row" spacing={1}>
          <TextField
            sx={{ width: "100%", backgroundColor: "white" }}
            label="Given Name"
            value={name.givenName}
            onChange={({ target: { value: givenName } }) =>
              updateName(index)({ givenName })
            }
          />
          <TextField
            sx={{ width: "100%", backgroundColor: "white" }}
            label="Family Name"
            value={name.familyName}
            onChange={({ target: { value: familyName } }) =>
              updateName(index)({ familyName })
            }
          />
        </Stack>
      ))}
      <TextField
        error={email && !isValidEmail(email) ? true : false}
        sx={{ backgroundColor: "white" }}
        label="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        sx={{ backgroundColor: "white" }}
        label="Phone Number (optional)"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
      />
      <TextField
        sx={{ backgroundColor: "white" }}
        label="Reference ID (optional)"
        value={sourceBookingId}
        onChange={(e) => setSourceBookingId(e.target.value)}
        InputProps={{
          endAdornment: (
            <Tooltip title="Here you can set an ID from your own system to be matched to this booking. This will be displayed on the invoice.">
              <HelpIcon />
            </Tooltip>
          ),
        }}
      />
    </Stack>
  );
}

export function isValidEmail(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
